import { render, staticRenderFns } from "./KoioteNavigationProperties.vue?vue&type=template&id=74f20916&lang=true"
import script from "./KoioteNavigationProperties.vue?vue&type=script&lang=js"
export * from "./KoioteNavigationProperties.vue?vue&type=script&lang=js"
import style0 from "./KoioteNavigationProperties.vue?vue&type=style&index=0&id=74f20916&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports